import { lineIds } from '@/data/Staff';
import type { TypeArg } from './FilterGroup';
import FilterGroup from './FilterGroup';

/**
 * All the legacy and modern dezrann types
 */
const defaultTypesDecl: TypeArg[] = [
  {
    type: 'Pattern', line: lineIds.bot2, color: 'auto', colorHueStart: 170, colorHueEnd: 250,
  },
  {
    type: 'Theme', line: lineIds.bot2, color: '#aa0033',
  },
  {
    type: 'Key', line: lineIds.bot2, color: '#330088',
  },
  {
    type: 'Modulation', line: lineIds.bot2, color: '#4400ee',
  },
  {
    type: 'Harmony', line: lineIds.bot1, color: '#330077',
  },
  {
    type: 'Harmony', tag: 'I', line: lineIds.bot1, color: '#9900ff',
  },
  {
    type: 'Harmony', tag: 'V', line: lineIds.bot1, color: '#6600bb',
  },
  {
    type: 'Pedal', line: lineIds.bot1, color: '#335555',
  },
  {
    type: 'Cadence', line: lineIds.all, color: '#ff00ff',
  },
  {
    type: 'Harmonic sequence', line: lineIds.bot3, color: '#ff8800',
  },
  {
    type: 'Texture', line: lineIds.bot3, color: '#22ff22',
  },
  {
    type: 'Structure', line: lineIds.top1, color: '#ffff00',
  },
  {
    type: 'Positive Feedback', color: '#99ff99', fontStyle: 'italic',
  },
  {
    type: 'Feedback', color: '#dddddd', fontStyle: 'italic',
  },
  {
    type: 'Negative Feedback', color: '#ff9999', fontStyle: 'italic',
  },
  {
    type: 'Comment', line: lineIds.bot3, color: '#dddddd', fontStyle: 'italic',
  },
];

/**
 * The default filters common to all analysis files
 *
 * A set of useful types with unique colors and css properties
 */
export const defaultTypes = FilterGroup.fromTypes(defaultTypesDecl);
